import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Badge, Row, UncontrolledTooltip } from "reactstrap";
import CheckGestalt from "../../../assets/images/icons/CheckGestalt";
import PlusOutlined from "../../../assets/images/icons/PlusOutlined";
import maaiaIconInfoYellow from "../../../assets/images/icons-infos-yellow.png";
import maaiaIconInfoPink from "../../../assets/images/icons-infos-pink.png";
import maaiaIconInfoPurple from "../../../assets/images/icons-infos-purple.png";
import { Client, Databases, Query } from "appwrite";
import TrashFilled from "../../../assets/images/icons/TrashFilled";

function MetaPostComponent(props) {
  const {
    index,
    messageToDelete,
    setMessageToDelete,
    message: conv,
    selectedMessage,
    multiSelectedMessage,
    setMultiSelectedMessage,
    goToMessageReadView,
    setSelectedMessageNext,
    messages,
    the_folder,
    setSelectedMessageNextIndex,
    actionConv,
    actionLoading,
    tag,
    togModalDossierVisibility,
    setShowReadEmailView,
    setStartCountdown,
    messagesTagsList,
    setMessagesTagsList,
    messagesStateList,
    setMessagesStateList,
    stringToColour,
    formaterDate,
    messageInfos,
    setMessageInfos,
    alertList,
    setAlertList
  } = props;

  const [hideTreatedMessages, setHideTreatedMessages] = useState({});

  async function getMessageInfos(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      // console.log("Fetching message info for " + messageID);
      const response = await databases.listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("conversation_id", messageID)
      ]);
      // console.log("response.documents.length is ", response.documents.length);
      return response.documents.length > 0 ? response.documents[0] : undefined;
    } catch (error) {
      console.log(error); // Echec
      console.log("Failed to fetch message info:", error);
      return undefined;
    }
  }

  async function getEmailTreatmentStatus(message_to_reply_id) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      const response = await databases.listDocuments(
        "default",
        "email_processing",
        [
          Query.equal("conversation_id", message_to_reply_id),
          Query.equal("company_id", localStorage.getItem("companyId"))
        ]
      );
      // console.log({ getEmailTreatmentStatus: response });

      if (response.total > 0) {
        return "true";
      } else {
        return "false";
      }
    } catch (error) {
      // console.log({ getEmailTreatmentStatus: error });
      return undefined;
    }
  }

  async function getAlerts(messageId) {
    try {
      if (!localStorage.getItem("companyId")) {
        return;
      }

      const client = new Client();
      const databases = new Databases(client, "default");
      client
        .setEndpoint(process.env.REACT_APP_DATABASEURL)
        .setProject(process.env.REACT_APP_PROJECTID);

      const response = await databases.listDocuments("default", "alert", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("active", true),
        Query.equal("client_message_id", messageId),
        Query.limit(100),
        Query.orderDesc("$createdAt")
      ]);
      // console.log("getAlert", { messageId, alerts: response.documents });
      return response.documents;
    } catch (error) {
      console.error("Failed to fetch alert data:", error);
      throw error; // Vous pouvez relancer l'erreur ou gérer l'erreur de manière appropriée ici
    }
  }
  function getMailTags() {
    if (!messagesTagsList[conv.$id]) {
      const all_related_messages = conv.related_messages
        ? [conv, ...conv.related_messages]
        : [conv];
      for (let i = 0; i < all_related_messages.length; i++) {
        fetchMessageTags(all_related_messages[i].$id, conv);
      }
    }
  }

  async function fetchMessageTags(messageId, the_message) {
    const tags =
      messageInfos[messageId] && messageInfos[messageId].contact_reasons
        ? messageInfos[messageId].contact_reasons
        : [];
    if (tags.length > 0) {
      const updatedTags = messagesTagsList[the_message.$id] || [];

      for (let index = 0; index < tags.length; index++) {
        if (!updatedTags.includes(tags[index])) {
          updatedTags.push(tags[index]);
        }
      }
      setMessagesTagsList((prevState) => ({
        ...prevState,
        [the_message.$id]: updatedTags
      }));
    }
  }

  async function getMailsDatas() {
    const message_infos_data = messageInfos;

    const the_message_infos_data = await getTheMessagesInfos(
      message_infos_data
    );
    console.log({ message_infos_data });

    setMessageInfos(the_message_infos_data);
    return the_message_infos_data;
  }

  async function getTheMessagesInfos(message_infos_data) {
    let all_r_msg = [...(conv.related_messages ?? [])];
    all_r_msg.push(conv);

    for (const theConv of all_r_msg) {
      if (!message_infos_data[theConv.$id]) {
        console.log("Before update:", theConv.$id, message_infos_data);
        const info = await getMessageInfos(theConv.$id);
        console.log("Fetched info for messageId", theConv.$id, info);
        message_infos_data[theConv.$id] = info ?? {};
      }
    }
    return message_infos_data;
  }

  async function getLastMessageProcessState(the_message_infos_data) {
    let theState;
    const msg =
      !conv.related_messages || conv.related_messages.length === 0
        ? conv
        : conv.related_messages[conv.related_messages.length - 1];

    const treatmentState = await getEmailTreatmentStatus(msg.$id, msg);
    console.log({ treatmentState });
    const this_message_infos_data = await getTheMessagesInfos({});

    const message_infos_data = messageInfos;
    message_infos_data[msg.$id] = this_message_infos_data[msg.$id];
    setMessageInfos(message_infos_data);

    if (!treatmentState || (treatmentState && treatmentState === "false")) {
      const process_state = this_message_infos_data[msg.$id]
        ? this_message_infos_data[msg.$id].process_state
        : undefined;
      console.log({
        subject: conv.message_subject,
        messageId: msg.$id,
        process_state
      });

      if (process_state) {
        theState = process_state;
        setMessagesStateList((prevState) => ({
          ...prevState,
          [conv.$id]: process_state
        }));
      } else {
        theState = "No Treatment";
        setMessagesStateList((prevState) => ({
          ...prevState,
          [conv.$id]: "No Treatment"
        }));
      }

      // theState = "-";
      // setMessagesStateList((prevState) => ({
      //   ...prevState,
      //   [message.$id]: "-",
      // }));
    } else if (treatmentState && treatmentState === "true") {
      theState = "Pending";
      setMessagesStateList((prevState) => ({
        ...prevState,
        [conv.$id]: "Pending"
      }));
    }
    // console.log({ theState });

    return theState;
  }

  function getMailsAlerts() {
    const all_related_messages = conv.related_messages
      ? [conv, ...conv.related_messages]
      : [conv];
    if (!alertList[conv.$id]) {
      for (let i = 0; i < all_related_messages.length; i++) {
        fetchMessageAlerts(all_related_messages[i].$id, conv);
      }
    }
  }

  async function fetchMessageAlerts(messageId, the_message) {
    try {
      const alerts = await getAlerts(messageId);

      const oldAlerts = alertList[the_message.$id] || [];
      setAlertList((prevState) => ({
        ...prevState,
        [the_message.$id]: [...oldAlerts, ...alerts]
      }));
    } catch (error) {
      console.log("No messageAlerts", error);
    }
  }

  useEffect(() => {
    getMailTags();
    getMailsAlerts();
  });

  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      const the_message_infos_data = await getMailsDatas();
      const lastMessageState = await getLastMessageProcessState(
        the_message_infos_data
      );
      if (lastMessageState !== "Treated" && lastMessageState !== "Untreated") {
        intervalId = setInterval(async () => {
          console.log(
            "Launching again getLastMessageProcessState for " + conv.$id
          );
          const updatedState = await getLastMessageProcessState(
            the_message_infos_data
          );
          //  console.log({ the_message_infos_data });
          // console.log({ updatedState });
          if (updatedState === "Treated" || updatedState === "Untreated") {
            clearInterval(intervalId);
          }
        }, 10000);
        // await new Promise((resolve) => setTimeout(resolve, 5000));
        // getLastMessageProcessState(messageInfos);
      }
    };
    fetchData();
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return (
    <Row className="mb-2">
      <div
        style={{
          padding: "0"
        }}
        className=""
      >
        <div
          className={`email-message font-primary  ${
            selectedMessage && selectedMessage.$id === conv.$id
              ? "email-message-background"
              : ""
          }`}
        >
          <div className="d-flex position-relative">
            <Badge
              className={`avatarBadge rounded-circle align-middle me-2 font-primary ${
                selectedMessage && selectedMessage.$id === conv.$id
                  ? "avatarBadge_selected"
                  : "avatarBadge_regular"
              }`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: "0",
                height: "30px !important",
                width: "30px !important",
                fontSize: " 14px",
                padding: "6px",
                cursor: "pointer"
              }}
              onClick={() => {}}
            >
              {conv.user_name
                ?.split(" ")
                .map((part) => part.charAt(0).toUpperCase())
                .join("")
                .slice(0, 2) ??
                "AA"
                  .split(" ")
                  .map((part) => part.charAt(0).toUpperCase())
                  .join("")
                  .slice(0, 2)}
            </Badge>

            <div
              style={{
                cursor: "pointer",
                padding: "0"
              }}
              onClick={() => {
                goToMessageReadView(conv);
                setSelectedMessageNext(messages[index + 1]);
                setSelectedMessageNextIndex(index + 1);
                console.log({
                  selectedMessage: conv,
                  selectedMessageNext: messages[index + 1]
                });
              }}
            >
              <div>
                {conv.origin === "whatsapp" ? (
                  <span style={{ fontSize: "9px" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="me-1"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                      />
                    </svg>
                    Synibox WhatsApp
                  </span>
                ) : conv.origin === "messenger" ? (
                  <span style={{ fontSize: "9px" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      className="me-1"
                    >
                      <path
                        fill="currentColor"
                        d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"
                      />
                    </svg>
                    Synibox Messenger
                  </span>
                ) : conv.origin === "instagram" ? (
                  <span style={{ fontSize: "9px" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="me-1"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
                      />
                    </svg>
                    Synibox Instagram
                  </span>
                ) : (
                  <span></span>
                )}
              </div>
              <div className="email-message-text font-primary">
                {" "}
                {conv.user_name ?? "Unknown"}{" "}
              </div>
              <div className="email-message-subject font-primary">
                {conv.last_message}
              </div>
              <div className="email-message-actions font-primary">
                {selectedMessage &&
                selectedMessage.$id === conv.$id &&
                multiSelectedMessage.length === 0 ? (
                  <>
                    {the_folder !== "Starred" && (
                      <button
                        className="message-action-starred font-primary"
                        style={{
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          actionConv(selectedMessage, "starred", false);
                        }}
                      >
                        {selectedMessage.tags === "starred" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="9"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.625 6.4L12 .725L16.375 6.4l6.85 2.3l-4.325 6.125l.175 6.825L12 19.675L4.925 21.65L5.1 14.8L.8 8.7z"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                          >
                            <path
                              d="M1.41788 7.87758C1.43318 7.64511 1.48418 7.41774 1.52244 7.19038C1.60405 6.69478 1.69076 6.19917 1.77747 5.70357C1.79277 5.62182 1.76472 5.56562 1.70861 5.50942C1.2113 5.02403 0.716545 4.53865 0.221789 4.05071C-0.0587433 3.77225 -0.0740451 3.35584 0.180984 3.05695C0.311049 2.90367 0.484469 2.83469 0.680841 2.80659C1.35412 2.70951 2.0274 2.61244 2.70067 2.51792C2.77718 2.5077 2.81799 2.46682 2.84859 2.40296C3.15207 1.78217 3.46066 1.16395 3.76414 0.543167C3.85085 0.366896 3.98347 0.239163 4.16709 0.170187C4.52158 0.0347907 4.90157 0.18807 5.07499 0.540612C5.35043 1.09242 5.63096 1.64422 5.89109 2.20625C5.99055 2.42084 6.10531 2.53069 6.35524 2.55624C6.95201 2.6201 7.54368 2.72484 8.13789 2.80659C8.51279 2.86024 8.75506 3.05695 8.82392 3.3865C8.88003 3.65729 8.80097 3.88977 8.6046 4.08136C8.12004 4.55653 7.63549 5.02914 7.14838 5.50175C7.07442 5.57328 7.05657 5.64226 7.07442 5.73934C7.19429 6.41376 7.3116 7.08819 7.42126 7.76262C7.46717 8.04874 7.37791 8.29654 7.14073 8.47026C6.90355 8.64653 6.63832 8.66952 6.37564 8.53413C5.77377 8.22246 5.17446 7.90568 4.57769 7.58635C4.46547 7.52504 4.37876 7.53015 4.2691 7.5889C3.67488 7.90824 3.07812 8.22246 2.4788 8.53157C2.08605 8.73339 1.63975 8.56478 1.46888 8.1637C1.43063 8.06663 1.41533 7.97466 1.41788 7.87758ZM6.79899 7.87247C6.79644 7.86481 6.79389 7.85203 6.79134 7.83926C6.68168 7.20571 6.58732 6.5696 6.4598 5.9386C6.38074 5.55029 6.46745 5.24884 6.76329 4.97805C7.22744 4.55142 7.66864 4.1018 8.12004 3.65985C8.16085 3.61897 8.2246 3.58321 8.2042 3.51168C8.18125 3.42993 8.10474 3.44015 8.04608 3.42993C7.38301 3.3303 6.71993 3.23322 6.05686 3.1387C5.77122 3.09782 5.56975 2.95732 5.44224 2.6993C5.14895 2.09895 4.85057 1.49861 4.55473 0.900819C4.52413 0.839507 4.50883 0.755203 4.42212 0.755203C4.33541 0.757758 4.32011 0.842062 4.29205 0.903373C3.99622 1.50372 3.69784 2.10151 3.40455 2.70185C3.28724 2.93943 3.10362 3.08505 2.84349 3.12848C2.65987 3.15913 2.4737 3.18213 2.28752 3.21023C1.77747 3.28431 1.26996 3.36095 0.7599 3.43504C0.711445 3.4427 0.66554 3.45036 0.645137 3.50401C0.624735 3.56021 0.662989 3.59342 0.696143 3.62664C0.84661 3.77481 0.994527 3.92042 1.14499 4.06859C1.49693 4.41347 1.85398 4.75579 2.20337 5.10323C2.37168 5.26928 2.44819 5.47621 2.41249 5.71123C2.36148 6.05356 2.29773 6.39588 2.23907 6.7382C2.17531 7.10608 2.11411 7.47139 2.05035 7.83926C2.0427 7.88524 2.04525 7.92101 2.08095 7.95167C2.11666 7.98488 2.15746 7.97466 2.19571 7.95678C2.21867 7.94656 2.24162 7.93378 2.26457 7.92101C2.85624 7.60934 3.44791 7.30023 4.03702 6.98601C4.29715 6.8455 4.54963 6.84805 4.80976 6.98856C5.28412 7.24403 5.76102 7.49183 6.23538 7.74218C6.37309 7.81371 6.51081 7.89035 6.65107 7.95933C6.73268 8.0002 6.79899 7.95678 6.79899 7.87247Z"
                              fill="#FFA412"
                            />
                          </svg>
                        )}
                        {/* {props.t("Suivre")} */}
                      </button>
                    )}
                    <button
                      className="message-action-moveto font-primary"
                      style={{
                        cursor: "pointer"
                      }}
                      disabled={actionLoading}
                      onClick={() => {
                        if (
                          selectedMessage.tags === "archive" ||
                          selectedMessage.tags === "draft" ||
                          selectedMessage.tags === "junk"
                        ) {
                          actionConv(selectedMessage, tag, true);
                        } else {
                          togModalDossierVisibility(true);
                        }
                      }}
                      // onClick={() => {
                      //   setType("move");
                      //   togModalDossierVisibility();
                      // }}
                    >
                      {selectedMessage.tags === "archive" ||
                      selectedMessage.tags === "draft" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="9"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M14.676 1.054a1 1 0 0 1 1.113.332l7 9a1 1 0 0 1 0 1.228l-7 9A1 1 0 0 1 14 20v-3.99c-5.379.112-7.963 1.133-9.261 2.243c-1.234 1.055-1.46 2.296-1.695 3.596l-.061.335a1 1 0 0 1-1.981-.122c-.172-2.748.086-6.73 2.027-10.061C4.913 8.768 8.305 6.282 14 6.022V2a1 1 0 0 1 .675-.946"
                            clip-rule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="9"
                          viewBox="0 0 9 9"
                          fill="none"
                        >
                          <path
                            d="M0.0064164 8.62134C0.00419534 8.45698 0.00197428 8.29484 0.00197428 8.13048C0.00197428 7.69737 -0.00246785 7.26649 0.00197428 6.83338C0.0175217 5.64289 0.421755 4.59677 1.21467 3.70835C1.93652 2.89988 2.83383 2.3957 3.89771 2.18914C4.06651 2.15583 4.23754 2.13584 4.40856 2.12473C4.4863 2.11807 4.50851 2.09141 4.50851 2.01368C4.50629 1.42954 4.50629 0.8454 4.50629 0.261261C4.50629 0.23905 4.50406 0.21684 4.50629 0.194629C4.50851 0.170197 4.49518 0.139103 4.52183 0.125776C4.54849 0.11245 4.56625 0.141324 4.58402 0.15465C5.15483 0.618852 5.72565 1.08527 6.29868 1.54948C7.02053 2.13806 7.74237 2.72442 8.46422 3.313C8.48198 3.32632 8.49975 3.33743 8.51974 3.35076C8.51974 3.36186 8.51974 3.37297 8.51974 3.38407C8.33984 3.51067 8.1777 3.65504 8.0089 3.79497C6.8806 4.71449 5.7523 5.63845 4.624 6.55797C4.59291 6.5824 4.56181 6.63571 4.52405 6.62016C4.4863 6.60239 4.50851 6.54464 4.50851 6.50466C4.50629 5.92052 4.50851 5.33639 4.50851 4.75225C4.50851 4.63231 4.50406 4.62787 4.37968 4.63897C3.71781 4.70116 3.09369 4.89217 2.51621 5.22089C1.70997 5.67843 1.08141 6.31365 0.668292 7.14655C0.468397 7.54856 0.30626 7.96612 0.128575 8.37924C0.0930378 8.46142 0.0597218 8.54138 0.0241849 8.62356C0.0175217 8.62133 0.0130796 8.62134 0.0064164 8.62134ZM5.02601 5.55405C5.06599 5.52518 5.0882 5.50963 5.10819 5.49408C5.95664 4.80111 6.80286 4.11036 7.65131 3.41961C7.70683 3.37519 7.69129 3.35076 7.64686 3.313C6.80286 2.62669 5.95886 1.93816 5.11486 1.25185C5.09487 1.23409 5.07488 1.20077 5.046 1.21187C5.01269 1.2252 5.02823 1.26518 5.02823 1.29405C5.02823 1.69607 5.02823 2.09808 5.02823 2.50009C5.02823 2.62447 5.02823 2.62447 4.90608 2.62669C4.62622 2.63113 4.34859 2.64224 4.07096 2.68888C3.18253 2.83769 2.41849 3.23082 1.77882 3.8616C1.1858 4.44574 0.801556 5.14982 0.619429 5.96272C0.594997 6.06711 0.572787 6.17373 0.566124 6.30255C0.594997 6.26479 0.610545 6.24258 0.626092 6.22037C1.11473 5.55405 1.72552 5.0321 2.46291 4.65674C3.23362 4.26583 4.05097 4.08149 4.91718 4.10592C5.02601 4.10814 5.02823 4.10814 5.02823 4.21697C5.02823 4.6212 5.02823 5.02544 5.02823 5.42967C5.02601 5.46521 5.02601 5.49852 5.02601 5.55405Z"
                            fill="#05B714"
                          />
                        </svg>
                      )}
                      {/* {props.t("Déplacer")} */}
                    </button>
                    {/* <button
                      className="message-action-trash me-0"
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        actionConv(
                          selectedMessage,
                          "junk",
                         selectedMessage.tags === "junk" ? true : false
                        );
                        // setMessageToDelete([selectedMessage.$id]);
                        // setShowReadEmailView(false);
                        // setStartCountdown(true);
                      }}
                    >
                      {selectedMessage.tags === "junk" ? (
                        <TrashFilled width="9" height="10" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                        >
                          <path
                            d="M4.05383 9.07683C3.6197 9.07683 3.18557 9.07942 2.75144 9.07683C2.52787 9.07423 2.30431 9.05863 2.08594 9.00664C1.58683 8.88706 1.29567 8.57771 1.20989 8.07079C1.16049 7.78483 1.1527 7.49628 1.1345 7.21033C1.09551 6.64102 1.05911 6.07171 1.02272 5.505C1.00192 5.19046 0.981124 4.87851 0.962927 4.56396C0.93953 4.19742 0.918734 3.83347 0.897937 3.46693C0.884939 3.26417 1.00452 3.10819 1.18389 3.09779C1.37626 3.0848 1.52184 3.21218 1.53483 3.41754C1.56863 3.91146 1.59982 4.40538 1.63102 4.9019C1.66741 5.44521 1.70641 5.98853 1.7402 6.52924C1.7636 6.87238 1.78179 7.21553 1.80519 7.55607C1.81299 7.67825 1.82339 7.80043 1.84158 7.92261C1.88838 8.23716 2.03395 8.37234 2.3537 8.40873C2.48368 8.42173 2.61106 8.42953 2.74104 8.42953C3.6171 8.42953 4.49315 8.42953 5.36661 8.42953C5.49919 8.42953 5.63177 8.42173 5.76435 8.40873C6.10229 8.37234 6.25827 8.20597 6.28686 7.84462C6.32326 7.32731 6.35445 6.80999 6.38825 6.29268C6.43244 5.64278 6.47663 4.99289 6.51823 4.34299C6.53902 4.02844 6.55722 3.71649 6.58062 3.40194C6.59361 3.20958 6.74179 3.0822 6.93416 3.09519C7.10833 3.10559 7.23051 3.25637 7.22011 3.44614C7.17852 4.12203 7.13693 4.79792 7.09533 5.47381C7.05634 6.07431 7.01995 6.67741 6.97835 7.27792C6.96016 7.53527 6.95236 7.79523 6.90816 8.05259C6.81198 8.6037 6.51303 8.91305 5.96192 9.02223C5.76435 9.06123 5.56418 9.07683 5.36401 9.07683C4.92469 9.07942 4.49056 9.07683 4.05383 9.07683Z"
                            fill="#F10944"
                          />
                          <path
                            d="M4.05885 0.121277C4.3526 0.129076 4.64895 0.10308 4.94271 0.155071C5.36644 0.230459 5.6108 0.464421 5.69658 0.888153C5.74078 1.10132 5.77717 1.31448 5.81097 1.53025C5.82136 1.59264 5.84736 1.62123 5.90975 1.62643C6.14631 1.64203 6.38027 1.65763 6.61684 1.67582C7.01457 1.70702 7.40971 1.74081 7.80744 1.77721C8.00241 1.79541 8.12719 1.94878 8.11159 2.13595C8.096 2.31012 7.94002 2.4375 7.74765 2.4219C7.4487 2.39851 7.14715 2.36731 6.8482 2.34132C6.53625 2.31532 6.2217 2.28933 5.90975 2.27113C5.05189 2.22434 4.19403 2.19314 3.33357 2.21394C2.68887 2.22954 2.04418 2.25553 1.40208 2.32312C1.06414 2.35951 0.72619 2.39071 0.385645 2.4219C0.177679 2.4427 0.0139055 2.31532 0.000907593 2.13335C-0.0120903 1.92798 0.115289 1.79281 0.333654 1.77201C0.78858 1.73042 1.24351 1.68362 1.69843 1.64463C1.85701 1.63163 2.01558 1.62383 2.17416 1.61603C2.25214 1.61344 2.29634 1.59004 2.30933 1.49905C2.33793 1.29369 2.37432 1.08832 2.41592 0.885553C2.5173 0.40983 2.81625 0.168069 3.30237 0.134275C3.55453 0.118677 3.80669 0.129076 4.05885 0.121277ZM4.83612 1.58484C4.90111 1.58484 4.9947 1.57964 5.08828 1.58744C5.15327 1.59264 5.16887 1.56664 5.15847 1.50945C5.12728 1.33788 5.09868 1.16631 5.06229 0.994735C5.03369 0.859557 4.9713 0.812765 4.83612 0.791968C4.60736 0.758174 4.376 0.776371 4.14724 0.776371C3.86388 0.776371 3.57793 0.755574 3.29457 0.789369C3.1438 0.807566 3.08401 0.859557 3.05281 1.01033C3.01902 1.17151 2.99562 1.33528 2.96183 1.49645C2.94883 1.55884 2.96963 1.58224 3.02942 1.57704C3.1438 1.57184 3.25558 1.56664 3.36996 1.56404C3.84828 1.55884 4.32661 1.55884 4.83612 1.58484Z"
                            fill="#F10944"
                          />
                          <path
                            d="M4.05648 5.13067C3.72633 5.13067 3.39619 5.13067 3.06604 5.13067C2.85028 5.13067 2.7021 5.00069 2.6969 4.81352C2.6917 4.62895 2.85028 4.48337 3.06604 4.48337C3.72633 4.48077 4.38923 4.48337 5.04952 4.48337C5.22369 4.48337 5.34327 4.56136 5.39526 4.70174C5.44466 4.83171 5.41086 4.9435 5.31468 5.03968C5.24449 5.10987 5.1561 5.13327 5.05732 5.13327C4.72197 5.13067 4.38923 5.13067 4.05648 5.13067Z"
                            fill="#F10944"
                          />
                          <path
                            d="M4.04608 6.7866C3.82251 6.7866 3.59895 6.7866 3.37538 6.7866C3.18562 6.7866 3.04004 6.64622 3.04004 6.46945C3.04004 6.29268 3.18562 6.1523 3.37538 6.1523C3.83031 6.1523 4.28264 6.1523 4.73756 6.1523C4.92473 6.1523 5.07291 6.29787 5.07031 6.47465C5.06771 6.64882 4.92473 6.7866 4.74016 6.78919C4.5088 6.7866 4.27744 6.7866 4.04608 6.7866Z"
                            fill="#F10944"
                          />
                        </svg>
                      )}
                      {/* {the_folder !== "Trash"
                        ? props.t("Corbeille")
                        : props.t("Supprimer")}
                    </button> */}
                  </>
                ) : (
                  <div
                    className="d-flex align-items-center"
                    style={{ maxWidth: "269px" }}
                  >
                    {messagesTagsList[conv.$id]
                      ? messagesTagsList[conv.$id]
                          .slice(0, 3)
                          .map((reason, index) => (
                            <div key={index} className="d-flex">
                              {index === 2 && (
                                <UncontrolledTooltip
                                  color="primary"
                                  placement="top"
                                  innerClassName="d-flex gap-1"
                                  style={{
                                    maxWidth: "500px",
                                    padding: "4px",
                                    border: "1px solid lightgray",
                                    background: "white",
                                    opacity: "1",
                                    flexWrap: "wrap"
                                  }}
                                  target={"TooltipWithHtml1" + conv.$id}
                                >
                                  {messagesTagsList[conv.$id]
                                    .slice(
                                      2,
                                      messagesTagsList[conv.$id].length + 1
                                    )
                                    .map((reason, index) => (
                                      <span
                                        id={index}
                                        className={`badge font-primary`}
                                        style={{
                                          backgroundColor: `${stringToColour(
                                            reason
                                          )}25`,
                                          color: stringToColour(reason),
                                          display: "flex",
                                          padding: "4px"
                                        }}
                                      >
                                        {props.t(reason)}
                                      </span>
                                    ))}
                                </UncontrolledTooltip>
                              )}

                              <div
                                id={
                                  index === 2
                                    ? "TooltipWithHtml1" + conv.$id
                                    : ""
                                }
                                className={`badge ${
                                  index === 2 ? "" : "me-1"
                                } font-primary`}
                                style={{
                                  backgroundColor: `${
                                    index === 2
                                      ? stringToColour(
                                          messagesTagsList[conv.$id][index - 1]
                                        )
                                      : stringToColour(reason)
                                  }25`,
                                  color:
                                    index === 2
                                      ? stringToColour(
                                          messagesTagsList[conv.$id][index - 1]
                                        )
                                      : stringToColour(reason),
                                  marginTop: "6px",
                                  display: "flex !important",
                                  padding: "4px",
                                  maxWidth: "84px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                }}
                              >
                                {index === 2 ? (
                                  <PlusOutlined height={12} width={12} />
                                ) : (
                                  props.t(reason)
                                )}
                              </div>
                            </div>
                          ))
                      : ""}
                  </div>
                )}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div
                className="email-message-date font-primary"
                style={{ minWidth: "45px" }}
              >
                {formaterDate(conv.timestamp_last_message)}
              </div>
              {messagesStateList[conv.$id] &&
              messagesStateList[conv.$id] === "Treated" ? (
                <img
                  src={maaiaIconInfoPurple}
                  alt="Synibox Icon Info Purple"
                  style={{
                    width: "24px",
                    height: "24px"
                  }}
                />
              ) : messagesStateList[conv.$id] &&
                messagesStateList[conv.$id] === "Untreated" ? (
                <img
                  src={maaiaIconInfoPink}
                  alt="Synibox Icon Info Pink"
                  style={{
                    width: "24px",
                    height: "24px"
                  }}
                />
              ) : messagesStateList[conv.$id] &&
                messagesStateList[conv.$id] === "Pending" ? (
                <img
                  src={maaiaIconInfoYellow}
                  alt="Synibox Icon Info Yellow"
                  style={{
                    width: "24px",
                    height: "24px"
                  }}
                />
              ) : (
                <div></div>
                // <img
                //   src={maaiaIconInfoYellow}
                //   alt="Synibox Icon Info Yellow"
                //   style={{
                //     width: "24px",
                //     height: "24px",
                //   }}
                // />
              )}
            </div>
          </div>
          <hr className="mails-separator" style={{ margin: "0 24px" }} />
        </div>
      </div>
    </Row>
  );
}

export default withTranslation()(MetaPostComponent);
